var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options, customNav) {
		var $owl = $(id);
		if (customNav) {
			$owl.on('initialize.owl.carousel', function() {
				site.frontpage.updateOwlNav();
			});
		}
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
		return $owl;
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.scrolling = {

	init: function () {
		$(document).scroll(function () {
			var $header = $("#header");
			var $banner = $("#banner");
			var $toggleMenu = $("#mainmenuToggle");
			var $checkAvalability = $("#godoCheckButton");
			$header.toggleClass('scrolled', $(this).scrollTop() > $banner.height() - $header.height());
			$toggleMenu.toggleClass('scrolled', $(this).scrollTop() > $banner.height() - $header.height());
			$checkAvalability.toggleClass('fixBottom', $(this).scrollTop() > $banner.height() + 20);
		});
	}
};

site.frontpage = {

	init: function() {
		var $owl = site.owl.init('.category.rooms .items', {
			items: 1,
			loop: true,
			nav: true,
			navText: ['', ''],
			smartSpeed:800
		}, true);

		$owl.on('changed.owl.carousel', function() {
			site.frontpage.updateOwlNav();
		});

		$(window).load(function () {
			site.content.fixWidth('#front-boxes h2');
		});
		$(window).resize(function () {
			site.content.fixWidth('#front-boxes h2');
		});
	},

	updateOwlNav: function() {
		setTimeout(function() {
			var $activeItem = $('.owl-item.active');
			var $prev = $activeItem.prev().find('h3').text();
			var $next = $activeItem.next().find('h3').text();

			$('.owl-prev').text($prev);
			$('.owl-next').text($next);
		},100);
	}
};

site.content = {
	fixWidth: function(element) {
		$(element).each(function () {
			var $this = $(this);
			if ($this.find('span').length === 0) {
				$this.wrapInner('<span />');
			}
			var $span = $('span', $this).removeAttr('style');
			$span.css('width', $span.width() + 1);
		});
	}
};

site.owlCar = {
	init: function () {
			site.owl.init('.room .albums .album .carousel', {
			items: 1,
			loop: true,
			nav: true,
			navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>']
		}, false);
	}
};

site.review = {
	init: function () {
		var $body = $('body');

		$('.reviewsOpen').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			$body.toggleClass('review-open');

			if ($body.hasClass('review-open')) {
				$('#reviewsContent>.wrapper').removeAttr('style').css('min-height', $body.outerHeight(true));
			}
		});

		$('.reviewClose').on('click', function(e) {
			$body.removeClass('review-open');
		}).on('blur', function(e) {
			$body.removeClass('review-open');
		});

		$('.reviewsInnest').on('click', function (e) {
			e.stopPropagation();
		});

		$body.click(function (e) {
			if ($body.hasClass('review-open')) {
				$body.removeClass('review-open');
			}
		});

		// Close search if escape key is pressed
		$(document).keyup(function (e) {
			if (e.keyCode === 27) {
				if ($body.hasClass('review-open')) {
					$body.removeClass('review-open');
				}
			}
		});
	}
};

site.roomLines = function () {
	$('.extras .albumInfo .description > h2').each(function () {
		var $this = $(this);
		$this.find('> .lines').width($this.width()).height($this.height());
	});
};
site.inits.push('site.roomLines()');

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});


	site.accessibility.init();
	site.scrolling.init();
	site.owlCar.init();
	site.review.init();
	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

$(window).resize(function () {
	site.roomLines()
});
